// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class AccountLinkedPayorModel {
    static getAttributeTypeMap() {
        return AccountLinkedPayorModel.attributeTypeMap;
    }
}
AccountLinkedPayorModel.discriminator = undefined;
AccountLinkedPayorModel.additionalProperties = false;
AccountLinkedPayorModel.attributeTypeMap = [
    {
        "name": "coverageOrder",
        "baseName": "coverageOrder",
        "type": "number"
    },
    {
        "name": "insurancePayorId",
        "baseName": "insurancePayorId",
        "type": "number"
    },
    {
        "name": "pbmPayorId",
        "baseName": "pbmPayorId",
        "type": "number"
    },
];
//# sourceMappingURL=accountLinkedPayorModel.js.map